// extracted by mini-css-extract-plugin
export var activeOffice = "globe-module--active-office--SFE1t";
export var colGlobe = "globe-module--col-globe--Z4KpN";
export var colGlobeInner = "globe-module--col-globe-inner--78sY6";
export var colMenu = "globe-module--col-menu--jPkuX";
export var columnCopy = "globe-module--column-copy--9JOnY";
export var columnImage = "globe-module--column-image--fTgMe";
export var globe = "globe-module--globe--m+a6r";
export var globeMenu = "globe-module--globe-menu--+09WF";
export var globeMenuItemFull = "globe-module--globe-menu-item-full--wybRc";
export var globeWrap = "globe-module--globe-wrap--V1JIU";
export var globeWrapFull = "globe-module--globe-wrap-full--PM3br";
export var jobLink = "globe-module--job-link--OZ8d5";
export var largeBlob = "globe-module--large-blob--LDfS8";
export var linkWrap = "globe-module--link-wrap--Af1N+";
export var urlLink = "globe-module--url-link--7OpOr";